// extracted by mini-css-extract-plugin
export default {"socialNetwork":"SocialNetwork_socialNetwork__VfV3-","icon":"SocialNetwork_icon__hdYe5","link":"SocialNetwork_link__u5Qdl"};